export enum ServiceSelection {
  Storage = 'storage',
  Moving = 'moving',
}
